import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {IDropdownItem} from '@irb-common/models/dropdown.model';

@Component({ standalone: false,
  selector: "irb-dropdown-cell",
  template: `
      <irb-dropdown-search
              #dropdownSearch
              [(value)]="value"
              (search)="populateDropdown($event)"
              (selection)="onSelect($event)"
              (clearSelection)="onClearSelection()"
              (keydown)="$event.stopPropagation()"
              [placeholder]="placeholder"
              [disabled]="disabled"
              [addNewItem]="addNewItem"
              [hoverPanelWidth]="hoverPanelWidth"
              (openNewItemFlow)="openNewItemFlow($event)"
              [editIconOnHover]="editIconOnHover"
      ></irb-dropdown-search>
    `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DropdownSearchRendererComponent implements ICellRendererAngularComp, AfterViewInit {
  @ViewChild('dropdownSearch') dropdownSearch: any;

  params: any;
  value: IDropdownItem;
  isNotApplicable: boolean = false;
  placeholder: string;
  disabled: boolean = false;
  addNewItem: any = null;
  hoverPanelWidth: number;
  topArrayElements: any;
  editIconOnHover: boolean = false;

  constructor() {}

  agInit(params: any) {
    this.params = params;
    this.value = this.params.defaultValue;
    this.isNotApplicable = (typeof this.params.isNotApplicable !== "undefined") ? this.params.isNotApplicable : false;    
    this.placeholder = (typeof this.params.placeholder !== "undefined") ? this.params.placeholder : "-Search-";
    this.disabled = this.params.disabled ? this.params.disabled(params) : false;
      this.hoverPanelWidth = (typeof this.params.hoverPanelWidth !== "undefined") ? this.params.hoverPanelWidth : 300;
      this.addNewItem = this.params.addNewItemConfig || null;
    if (this.isNotApplicable) {
      this.value = {
        name: "n/a",
        value: null
      };
    }
    this.topArrayElements = this.params.topArrayElements || null;
    this.editIconOnHover = this.params.editIconOnHover || false;
  }

  ngAfterViewInit() {
    this.dropdownSearch.setDisabled((this.params.isDisabled) ? this.params.isDisabled() : false);
  }

  refresh(): boolean {
    this.dropdownSearch?.setDisabled((this.params.isDisabled) ? this.params.isDisabled() : false);
    return true;
  }

  populateDropdown(searchString: string): void {
    if (searchString && searchString.length > 0) {
      let populatedArray: any = (this.params.values || [])
          .filter((item: any) => item.name &&
              item.name.toUpperCase().startsWith(searchString.toUpperCase()));
      if (this.topArrayElements && populatedArray.length !== 0 && searchString !== '')
        populatedArray = this.topArrayElements.concat(populatedArray);
      this.dropdownSearch.set(populatedArray)
    }
  }

  onSelect(itemSelected: IDropdownItem): void {
    this.value = itemSelected;
    
    if(this.params.onChange) {
      this.params.onChange(this.params, this.value);
    }
  }

  onClearSelection(): void {
    if(this.params.onClearSelection) {
      this.params.onClearSelection(this.params);
    }
  }

    openNewItemFlow(event: any) {
        if (this.params.openNewItemFlow) {
            this.params.openNewItemFlow(event);
        }
    }
}
